import { animate, inView, spring } from "motion";
import {  section_scroll_into_view, } from "./animation-utils.mjs";

window.addEventListener("DOMContentLoaded", () => {
  // Breakpoints for media queries:
  const bp_sm = 576,
    bp_md = 768,
    bp_lg = 992,
    bp_xl = 1200,
    bp_xxl = 1400;

  // MOTION ONE ANIMATIONS ==================================
  // if set to true, procede with animations:
  if (animationsEnabled) {
    // section break animation (before the footer)
    inView(
      document.querySelector("footer"),
      ({ target }) => {
        const spinningGem = animate(
          target.querySelector('[data-animate-id="spinning-gem"]'),
          { rotateY: [0, 360], opacity: [0, 1], y: [-40, 0], scaleY: [0.8, 1] },
          {
            delay: 1,
            easing: "ease-out",
            opacity: { duration: 0.1 },
            rotateY: { duration: 1.3 },
            scaleY: { duration: 0.2 },
          }
        );
        const horizontalLines = animate(
          target.querySelectorAll(".gem .line"),
          { opacity: [1, 1], scaleX: [0, 1] },
          { easing: "ease-out", duration: 0.8 }
        );
        // return (leaveInfo) => {
        //   spinningGem.stop();
        //   horizontalLines.stop();
        // };
      },
      { amount: 0 }
    );

    // footer animation ===================================
    section_scroll_into_view(".carousel-content", ".stack-item", true);
    section_scroll_into_view("footer", ".row > div", true);
    section_scroll_into_view(
      "social-icons",
      ".social-link",
      true,
      // override default animation:
      { x: [-20, 0], y: [0, 0], rotate: ["-20deg", "0deg"] },
      { easing: spring({ velocity: 50 }) }
    );

    // header navigation animation ==================================
    const header_y_offset = 66,
      header = document.querySelector('[data-animate="header-nav"]'),
      headerID = document.querySelector("#header-nav");
    function header_nav_transform() {
      // if screen is larger than bp_lg adjust y position of header:
      if (window.innerWidth > bp_lg) {
        if (window.scrollY > header_y_offset) {
          header.style.transform = "translateY(-" + header_y_offset + "px)";
        } else {
          header.style.transform = "translateY(0)";
        }
      } else {
        // otherwise add .scrolled class to header and prevent y-transform,
        // so more detailed adjustments can be made:
        header.style.transform = "translateY(0)";
        if (window.scrollY > header_y_offset) {
          headerID.classList.add("scrolled");
        } else {
          headerID.classList.remove("scrolled");
        }
      }
    }
    if (header) {
      // add event listeners to scroll and resize events:
      window.addEventListener("scroll", header_nav_transform);
      window.addEventListener("resize", header_nav_transform);
      // run the function once on load:
      header_nav_transform();
    }

    // Incrementing numbers animation ==================================
    const incrementNumbers = document.querySelectorAll(
      '[data-animate="increment-number"]'
    );
    if (incrementNumbers.length !== 0) {
      // if current url is within /profile, don't animate
      if (window.location.pathname.includes("/profile")) return;

      incrementNumbers.forEach((el) => {
        // wait for element to be in view
        inView(el, ({ target }) => {
          // place a span inside of el
          el.style.position = "absolute";
          // parent needs to be relative
          el.parentElement.style.position = "relative";
          // clone el as sibling, then set it to position relative/opacity 0
          // so that it holds the space
          const clone = el.cloneNode(true);
          el.parentElement.appendChild(clone);
          clone.style.cssText = "position: relative; opacity: 0;";
          const value = parseInt(el.textContent.replace(/,/g, "")),
            increment = Math.ceil(value / 100);
          let current = 0;
          const interval = setInterval(() => {
            current += increment;
            if (current >= value) {
              clearInterval(interval);
              current = value;
            }
            el.textContent = current.toLocaleString();
          }, 10);
          // return (leaveInfo) => {
          //   clearInterval(interval);
          //   el.textContent = value.toLocaleString();
          //   el.parentElement.removeChild(clone);
          // };
        });
      });
    }

    // Activate anchor links: ==================================
    // when anchor is in view, add .active to the .nav-link that links to it
    // https://motion.dev/dom/in-view
    function activateAnchorLinks() {
      document.querySelectorAll(".skip-link").forEach((anchor) => {
        const id = anchor.getAttribute("id"),
          navLinks = document.querySelectorAll(`.nav-link[href="#${id}"]`),
          scrollContainer = document.querySelector("[data-sticky-at] ul.nav");
        navLinks.forEach((navLink) => {
          if (navLink.getAttribute("href") === `#${id}`) {
            let activeAnchorWrapper = document.querySelector(
              `[data-in-view="${id}"]`
            );
            let activeLink = document.querySelector(`a[href="#${id}"]`);
            inView(
              activeAnchorWrapper,
              () => {
                activeLink.classList.add("active");
                activeLink.parentElement.classList.add("active");

                // horizonal scroll to active link:
                // scroll to the left if the active link is to the right of the screen:
                if (
                  activeLink.getBoundingClientRect().right > window.innerWidth
                ) {
                  // how it works:
                  // - get the right offset of the active link:
                  // - subtract the window width to get the offset from the right edge of the screen
                  // - add 20px to give some space between the active link and the right edge of the screen
                  // - add the current scroll position to get the final offset
                  var left_offset =
                    scrollContainer.scrollLeft +
                    activeLink.getBoundingClientRect().right -
                    window.innerWidth +
                    20;
                  scrollContainer.scrollTo({
                    left: left_offset,
                    behavior: "smooth",
                  });
                }
                // for the left side of the screen:
                if (activeLink.getBoundingClientRect().left < 0) {
                  var left_offset =
                    scrollContainer.scrollLeft +
                    activeLink.getBoundingClientRect().left -
                    20;
                  scrollContainer.scrollTo({
                    left: left_offset,
                    behavior: "smooth",
                  });
                } // end of horizontal scroll

                // remove active links when they leave the viewport:
                return (leaveInfo) => {
                  activeLink.classList.remove("active");
                  activeLink.parentElement.classList.remove("active");
                };
              },
              {
                // Margin
                // A CSS margin to apply to the root viewport so an element can be considered in view sooner or later.
                // Can be in pixels or percentages. Positive values extend the viewport boundaries beyond the root whereas
                // negative values will pull it in.
                // How it's used here:
                // - top: -200px - Element is considered out of view 200px before it's out of view
                // - bottom: -75% - Element isn't considred in view until 75% of it is in view
                margin: "-200px 0px -75%  0px",
              }
            );
          }
        });
      }); // end of anchors.forEach
    } // end of activateAnchorLinks function

    // sticky headers ==================================
    // use data-sticky-at="value" to set the offset of a sticky header
    // this will impact margin, padding, and top values of the sticky element,
    function stickyHeaders() {
      const elements = document.querySelectorAll("[data-sticky-at]");
      if (elements.length === 0) return;
      elements.forEach((el, index) => {
        let el_value = el.getAttribute("data-sticky-at");
        if (el_value === "disabled") return;
        if (el_value === "auto") {
          let offsets = ["23", "80", "200", "270"];
          if (window.innerWidth > bp_lg) {
            offsets = ["53", "120", "200", "270"];
          }
          el_value = offsets[index];
        } else {
          if (window.innerWidth < bp_lg) el_value = el_value - 26;
        }
        let margin_offset = parseInt(el_value) + 11;
        const observer = new IntersectionObserver(
          ([e]) => {
            e.target.classList.toggle("is-pinned", e.intersectionRatio < 1);
            e.target.style.cssText = `
                  top: -1px;
                  margin-top: -${margin_offset}px;
                  padding-top: ${margin_offset}px;
                  position: sticky;
                `;
            // the smaller the top offset, the higher the z-index:
            e.target.style.zIndex = 1000 - el_value;
          },
          { threshold: [1] }
        );
        observer.observe(el);
      }); // end of elements.forEach (sticky headers)
    } // end of stickyHeaders function

    // run sticky headers and anchor links:
    stickyHeaders();
    activateAnchorLinks();
    // watch for resize events and re-run stickyHeaders:
    window.addEventListener("resize", function () {
      // Clear the timeout if it's already set.
      clearTimeout(this.resizeTimeout);
      // Set a timeout to run after the resize event has finished.
      this.resizeTimeout = setTimeout(function () {
        stickyHeaders();
        activateAnchorLinks();
      }, 500); // Delay in milliseconds. Adjust this value as needed.
    });

    window.addEventListener("scroll", function () {
      // Clear the timeout if it's already set.
      clearTimeout(this.scrollTimeout);
      // Set a timeout to run after the scroll event has started.
      this.scrollTimeout = setTimeout(function () {
        stickyHeaders();
        activateAnchorLinks();
      }, 100); // Delay in milliseconds. Adjust this value as needed.
    });

        // animate rewards description ===========================
        const rewards_description = document.querySelector('[animate-id="rewards-description"]');
        if (rewards_description) {
          scroll(
            animate(
              rewards_description,
              { opacity: [1,1], y: [20,0], scale: [0.95,1] },
              { delay: 0, easing: [0.22, 1, 0.36, 1], duration: 1.2, opacity: { duration: 0.5 } }
            ),
            {
              target: rewards_description,
              offset: ['start end', 'start center']
            }
          );
        }

    } // end if animations enabled


});
